import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export const useTruTableStyles = () => {
  return useStyles(({theme, mediaOnly}) => ({
    cellStyle: {
      flexBasis: 250,
    },
    colText: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5Light,
          color: theme.color.textColor,
        },
        {
          fontSize: 18,
          fontWeight: 'bold',
          color: theme.color.textColor,
        },
      ),
    },
    colTextPrimary: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5Light,
          color: theme.color.primaryColor,
        },
        {
          fontSize: 18,
          fontWeight: 'bold',
          color: theme.color.primaryColor,
        },
      ),
    },
    colTextSecondary: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5Light,
          color: theme.color.primaryColor,
        },
        {
          fontSize: 18,
          fontWeight: 'bold',
          color: theme.color.iconGrayColor,
        },
      ),
    },
  }));
};
